import { capexService } from '@modules/capex/infrastructure/capex.service'
import { CapexData } from '@modules/capex/domain/capex.types'

type Callbacks = {
  onCapexData: (capex: CapexData[]) => void
  onNetworkError: (error: unknown) => void
}

export function handleGetCapexData() {
  return { execute }

  async function execute({ onCapexData, onNetworkError }: Callbacks) {
    try {
      const capexDataList = (await capexService.getCapexData()) as CapexData[]
      onCapexData(capexDataList)
    } catch (error) {
      onNetworkError(error)
    }
  }
}
